window.dtEmployeeSalaryComponent = function () {
  const dtEmployeeSalaryComponent = new DataTable('#employee-salary-component-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#employee-salary-component-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#employee-salary-component-datatable', 5); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[1, 'asc']],
    columns: [
      { data: "index" },
      { data: "employee_name" },
      { data: "position" },
      { data: "pin" },
      { data: "payroll_status" }
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row) {
      $('td', row).addClass('py-1');
    }
  });

  dtFinalTouch();
}
